import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" }
});

// Attach admin token (when present) to all requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("fw_admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const submitContact = (payload) => api.post("/contact", payload).then(r => r.data);
export const submitCallback = (payload) => api.post("/callback", payload).then(r => r.data);
export const adminLogin = (password) => api.post("/admin/login", { password }).then(r => r.data);
export const adminMe = () => api.get("/admin/me").then(r => r.data);
export const fetchContacts = () => api.get("/contact").then(r => r.data);
export const fetchCallbacks = () => api.get("/callback").then(r => r.data);

// Blog
export const fetchBlogPosts = (includeUnpublished = false) =>
    api.get(`/blog${includeUnpublished ? "?include_unpublished=true" : ""}`).then(r => r.data);
export const fetchBlogPost = (slug) => api.get(`/blog/${slug}`).then(r => r.data);
export const createBlogPost = (payload) => api.post("/blog", payload).then(r => r.data);
export const updateBlogPost = (slug, payload) => api.put(`/blog/${slug}`, payload).then(r => r.data);
export const deleteBlogPost = (slug) => api.delete(`/blog/${slug}`).then(r => r.data);
